"use client";

import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { MenuType } from "../../../../MenuType";
import { useMenuStore } from "../../../../store/stores";
import useShowFooter from "../../../../Hooks/useShowFooter";
import { useCore } from "../../../../../core-nextv3/core/core";
import { header_submenu_animation } from "../../../../../animation";
import { MENU_HEADER_STATIC, THEME_SETTING } from "../../../../../setting/setting";
import { ImageSet } from "@/component-nextv3/ImageSet";
import { useAppContext } from "@/veria-nextv1/Providers/app.providers";
import { TopHeader } from "./TopHeader";
import CustomLink from "@/component-nextv3/CustomLink";

export const HeaderDesk = () => 
{
    const isScrollingUp                = useShowFooter();
    const { toggleCart, toggleSearch } = useMenuStore();  
    const { menuData, topHeaderData }  = useAppContext();
    const { cart, user }               = useCore();
  
    return (
        <>
            <TopHeader topHeader={topHeaderData}/>

            <header
                className={`${styles.headerDesk} ${styles.desktop} ${
                    styles[isScrollingUp ? "stickyDown" : "stickyUp"]
                }`}
                id="headerDesk"
            >
                <div className={styles.content}>
                    <nav className={styles.menu}>
                        <motion.ul>
                            {MENU_HEADER_STATIC && MENU_HEADER_STATIC?.map((item: any, index: any) => (
                                <motion.li
                                    key={index}
                                    initial="animate"
                                    animate="animate"
                                    whileHover="hover"
                                    className={styles.menuItemGrid}
                                >
                                    {item?.children?.length > 0 ?
                                        <>
                                            {item?.label}
                                            <motion.ul
                                                className={styles.subMenuGrid}
                                                variants={header_submenu_animation}
                                            >
                                                <div className={styles.subMenu}>
                                                    {item?.children?.map((child: any, index: any) => (
                                                        <div className={styles.subMenuChild} key={index}>
                                                            <CustomLink href={child?.url}>
                                                                <span>
                                                                    {child?.label}
                                                                </span>
                                                            </CustomLink>
                                                        </div>
                                                    ))}
                                                </div>
                                            </motion.ul>
                                        </>
                                        :
                                        <motion.ul>
                                            <motion.li>
                                                <CustomLink href={item?.url}>
                                                    {item?.label}
                                                </CustomLink>                                                
                                            </motion.li>
                                        </motion.ul> 
                                    }
                                </motion.li>
                            ))}
                        </motion.ul>
                    </nav>
                    <CustomLink href="/">
                        <ImageSet
                            alt=""
                            className={styles.logo}
                            src="/images/logo_black.png"
                            width={THEME_SETTING.widthLogo}
                            height={THEME_SETTING.heightLogo}
                            responsive={false}
                        />
                    </CustomLink>
                    
                    {/* <Image
            width={980}
            height={166.04}
            src="/images/logo_black.png"
            alt="Logo"
            className={styles.logo}
            onClick={() => route("/")}
          /> */}
                    <nav className={styles.navigation}>
                        <CustomLink href="/lista-de-desejos/">
                            <ImageSet
                                width={20}
                                height={20}
                                src="/assets/icons/heart.png"
                                responsive={false}
                                alt=""
                            />
                        </CustomLink>
                        <ImageSet
                            width={18}
                            height={18}
                            src="/assets/icons/search.png"
                            priority
                            alt="Pesquisar"
                            responsive={false}
                            onClick={toggleSearch}
                        />
                        <div>
                            <ImageSet
                                width={18}
                                height={18}
                                src="/assets/icons/cart.png"
                                priority
                                alt="Carrinho"
                                responsive={false}
                                onClick={toggleCart}
                            />
                            <small>{cart?.items?.length || 0}</small>
                        </div>
                        <CustomLink href={user ? "/perfil/" : "/login/"}>
                            <ImageSet
                                width={18}
                                height={18}
                                src="/assets/icons/user.png"
                                priority
                                alt="User"
                                responsive={false}
                            />
                        </CustomLink>                        
                        {/* <ImageSet
                            width={18}
                            height={18}
                            src="/assets/icons/live.png"
                            priority
                            alt="Coleções" 
                            responsive={false}
                            onClick={() => customPush("/colecoes/")}
                        /> */}
                    </nav>
                </div>
            </header>
            <header
                className={`${styles.subHeaderDesk} ${styles.desktop} ${
                    styles[isScrollingUp ? "stickyDown" : "stickyUp"]
                }`}
                id="subHeaderDesk"
            >
                <div className={styles.content}>
                    <nav className={styles.menu}>
                        <ul>
                            <MenuType menu={menuData} />
                            {/* {menu?.map((item: any, index: any) => (
              <motion.li
              className={styles.menuItemGrid}
              initial="animate"
              animate="animate"
              whileHover="hover"
              key={index}
              onClick={() => route(item?.link)}
              >
                {item?.name}
                <motion.ul
                  className={styles.subMenuGridSub}
                  variants={header_submenu_animation}
                >
                  {item?.children?.map((child: any, index: any) => (
                    <p key={index}>
                      {child?.label}
                    </p>
                  ))}
                  <p>Teste de categorias</p>
                </motion.ul>
              </motion.li>
              // <li onClick={() => route(item?.link)} key={index}>{item?.name}</li>
            ))} */}
                        </ul>
                    </nav>
                </div>
            </header>
        </>
    );
};
